import { Link } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/lib/content";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHeader
        overline="Questions & answers"
        title="Frequently asked"
        italic="questions."
        subtitle="Everything you might be wondering about lessons, safety, scheduling and the Mimi & Me approach."
      />

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <Reveal key={i} delay={(i % 6) * 0.04}>
                <AccordionItem value={`item-${i}`} className="border-b" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="group py-6 text-left font-display text-xl md:text-2xl hover:no-underline [&>svg]:hidden" style={{ color: "var(--navy)" }}>
                    <span className="flex-1 pr-4">{f.q}</span>
                    <span className="relative flex-shrink-0 w-6 h-6">
                      <Plus size={22} className="absolute inset-0 group-data-[state=open]:opacity-0 transition-opacity" style={{ color: "var(--gold)" }} />
                      <Minus size={22} className="absolute inset-0 opacity-0 group-data-[state=open]:opacity-100 transition-opacity" style={{ color: "var(--gold)" }} />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="font-body font-light text-base leading-relaxed pb-6" style={{ color: "var(--muted)" }}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>

          <Reveal>
            <div className="mt-14 text-center p-10 rounded-2xl" style={{ backgroundColor: "var(--sand)" }}>
              <h3 className="font-display text-2xl md:text-3xl" style={{ color: "var(--navy)" }}>Still have a question?</h3>
              <p className="font-body font-light mt-2" style={{ color: "var(--muted)" }}>I'd love to help you and your little swimmer.</p>
              <Link to="/contact" className="btn-primary mt-6">Contact Mimi & Me</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
